import { render, staticRenderFns } from "./BankAdd.vue?vue&type=template&id=3fd3ad24&"
import script from "./BankAdd.vue?vue&type=script&lang=js&"
export * from "./BankAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports